import $ from "jquery";
import { toggleHeaderBorder } from './Helpers/headerBorderToggler';

export class SearchModule {

    constructor(menuModule) {
        this.$overlay = $('.site-header__search');
        this.$menuSearchButton = $('.btn--search');
        this.$searchIcon = this.$menuSearchButton.find('.menu-search-icon');
        this.$closeIcon = this.$menuSearchButton.find('.menu-close-icon');
        this.$body = $('body');
        this.$menuButton = $('.menu-button.hamburger');
        this.menuModule = menuModule;
    }

    init() {
        this.$menuSearchButton.on('click', (e) => { this.toggleSearchForm(e) });
    }

    toggleSearchForm(e) {
        if (this.searchIsOpen()) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
    }

    openSearch() {
        this.$overlay.addClass('site-header__search--active');
        this.$menuSearchButton.data('state', 'active');
        this.toggleIcons();
        this.menuModule.closeOverlay(true);
        this.menuModule.addBlueColors();
        toggleHeaderBorder(true);
        this.$body.addClass('prevent-scroll');
        this.$menuButton.addClass('added-alternative-hamburger');
    }

    closeSearch() {
        this.$overlay.removeClass('site-header__search--active');
        this.$menuSearchButton.data('state', 'inactive');
        this.toggleIcons();
        toggleHeaderBorder(false);
        if (!this.menuIsOpen()) {
            this.menuModule.revertBlueColors();
            this.$body.removeClass('prevent-scroll');
            this.$menuButton.removeClass('added-alternative-hamburger');
        }
        
    }

    toggleIcons() {
        this.$searchIcon.toggleClass('active');
        this.$closeIcon.toggleClass('active');
    }

    searchIsOpen() {
        return this.$menuSearchButton.data('state') == 'active';
    }

    menuIsOpen() {
        return this.$menuButton.hasClass('is-active');
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/SearchModule.js